import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import ChartsMenu from './ChartsMenu';
import Chart from './Chart';

export class Charts extends React.Component {
  state = {
    active: 'charts-table',
    menu: (fields, hasPivots) => [
      {
        id: 'charts-table',
        className: 'tvt-charts-icon tvt-charts-table-icon',
        disabled: false
      },
      {
        id: 'charts-column',
        className: 'tvt-charts-icon tvt-charts-column-icon',
        disabled: isEmpty(fields) || hasPivots
      },
      {
        id: 'charts-bar',
        className: 'tvt-charts-icon tvt-charts-bar-icon',
        disabled: isEmpty(fields) || hasPivots
      },
      {
        id: 'charts-line',
        className: 'tvt-charts-icon tvt-charts-line-icon',
        disabled: isEmpty(fields) || hasPivots
      },
      {
        id: 'charts-pie',
        className: 'tvt-charts-icon tvt-charts-pie-icon',
        disabled: isEmpty(fields) || hasPivots
      }
    ]
  };

  handleMenuClick = id => () => this.setState({ active: id });

  render() {
    const active =
      this.props.hasPivots || isEmpty(this.props.fields)
        ? 'charts-table'
        : this.state.active;

    return (
      <React.Fragment>
        <ChartsMenu
          active={active}
          list={this.state.menu(this.props.fields, this.props.hasPivots)}
          onClick={this.handleMenuClick}
        />
        <Chart
          active={active}
          data={this.props.data}
          fields={this.props.fields}
          loading={this.props.loading}
          rendered={this.props.rendered}
          TableComponent={() => this.props.children}
        />
      </React.Fragment>
    );
  }
}

Charts.propTypes = {
  children: PropTypes.node,
  data: PropTypes.array, // eslint-disable-line
  fields: PropTypes.array, // eslint-disable-line
  hasPivots: PropTypes.bool,
  loading: PropTypes.bool,
  rendered: PropTypes.bool.isRequired
};

Charts.defaultProps = {
  children: () => null,
  data: [],
  fields: [],
  hasPivots: false,
  loading: false
};

export default Charts;
